import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ standalone: false, name: 'mailstats' })
export class MailStatsPipe implements PipeTransform {
  transform(input: any, limit: number = 0): string {

    if (input == null) {
      return 'n/a';
    }

    const out = [];

    input.forEach(el => {
      out.push(`<label class="badge badge-${(limit !== -1 && el.passed >= limit ) ? 'danger' : 'success'}">${el.time}:00 Uhr (${el.passed} Mails / h)</label>`);
    });

    return out.join('<br>');
  }
}
